import React from 'react';

const PersonalDetailsSection = ({ email, onEmailChange }) => {
  return (
    <div className="bg-primary600 py-4 px-3 rounded-sm">
      <p className="font-inter font-medium text-sm leading-6">
        1. Personal details
      </p>

      <div className="flex sm:flex-row flex-col gap-3 mt-5">
        <div className="flex gap-3 md:flex-row flex-col !md:w-5/7 w-full">
          <div className="w-full">
            <p className="font-inter font-light text-[10px] text-dark-500">
              Email address
            </p>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={onEmailChange}
              required
              readOnly
              className="rounded-sm h-[34px] border-[0.78px] border-dark-500/20 outline-none px-[10.9px] mt-1 bg-primary-950 font-inter font-normal text-[12.45px] leading-[18.68px] w-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalDetailsSection;